import React from 'react';
import { Link } from 'react-router-dom';

const BrandLogo = () => {
    return (
        <Link to="/" className="group relative flex items-center gap-1">
            <div className="relative w-8 h-8 flex items-center justify-center bg-transparent">
                {/* Animated shape background */}
                <div
                    className="absolute inset-0 bg-gradient-to-tr from-primary-light to-secondary-light rounded-lg opacity-20 dark:opacity-40 animate-spin-slow"
                    style={{
                        animation: 'logoSpin 8s linear infinite'
                    }}
                />
                <span className="font-display font-black text-xl text-primary-light dark:text-white z-10 tracking-tighter">
                    T
                </span>
            </div>
            <div className="flex flex-col">
                <h1 className="font-display font-black text-2xl tracking-tight leading-none text-gray-900 dark:text-white transition-all duration-300">
                    TRENDZ
                </h1>
            </div>
        </Link>
    );
};

export default BrandLogo;
